import {useEffect, useState} from 'react';
import Label from "./Label";


const Radio = (options) => {
    const name = options && options.name != undefined ? options.name : '';
    const wrapper = options && options.wrapper != undefined ? options.wrapper : 'radio-group'
    const [value, setValue] = useState(options.value)


    useEffect(() => {
    }, [value])


    const handleChange = (event) => {
        if(typeof options.onChange == "function"){
            setValue(event.target.value)
            options.onChange(event.target.value)
        }
    }


    return (
        <div className="Radio">
            <div className={wrapper}>
                {options.label != null && <Label {...options} />}
                <div className="group-container">
                    <div className="items">
                    {
                        options && options.options && options.options.map((item, index) => {
                            return <label key={`radio_${name}_${index}`}>
                                    {item.icon && <span className={`icon ${value == item.value ? 'active' : ''}`}>{item.icon}</span>}
                                    {!item.icon && item.label && <span className={`icon ${value == item.value ? 'active' : ''}`}>{item.label}</span>}
                                    <input className={item.hide == true ? 'd-none' : ''} type="radio" name={name} checked={value == item.value} value={item.value} onChange={handleChange}/>
                            </label>
                        })
                    }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Radio;